__turbopack_context__.v({
  "error": "InputError-module-scss-module__Z4SUwq__error",
});
